import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Homepage.css';

const Homepage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="homepage-container">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>Celebrate, Don't Stress</h1>
          <p>Let's craft a ring as beautiful as your love story.</p>
          <div className="hero-buttons">
            <Link to="/quiz" className="cta-button">Get Matched</Link>
            <Link to="/collections" className="cta-button secondary">Collections</Link>
          </div>
        </div>
      </section>

      {/* Value Proposition Section */}
      <section className="value-prop">
        <div className="value-prop-grid">
          <div className="value-card celebrate">
            <div className="value-content">
              <h3>A Joyful Start to Forever</h3>
              <p>Finding the perfect ring should feel exciting, not exhausting. Our 2-minute Style Quiz is just the beginning—your personal concierge will hand-select conflict-free diamond options tailored to your love story, budget, and unique taste. No algorithms, no overwhelm—just expert-curated choices, so you can focus on the magic ahead.</p>
            </div>
          </div>
          <div className="value-card precision">
            <div className="value-content">
              <h3>Your Vision, Perfected by Experts</h3>
              <p>Forget scrolling endlessly. After your quiz, a specialist reviews your preferences and handpicks your top ring designs. Want to adjust the setting, stone size, or metal? Your dedicated diamond concierge will refine every detail until it's uniquely yours.</p>
            </div>
          </div>
          <div className="value-card sustainable">
            <div className="value-content">
              <h3>Ethical Beauty, No Compromises</h3>
              <p>Lab-grown diamonds offer identical brilliance, clarity, and durability as mined diamonds—but with a clear conscience. Sustainably created, budget-friendly, and certified conflict-free, they let you celebrate love without sacrifice.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Links Section */}
      <section className="quick-links">
        <div className="quick-links-grid">
          <Link to="/collections" className="quick-link-card">
            <h3>Shop Collections</h3>
            <p>Browse our curated selection of fine jewelry</p>
          </Link>
          <Link to="/blog" className="quick-link-card">
            <h3>Blog</h3>
            <p>Expert insights and jewelry education</p>
          </Link>
          <Link to="/our-story" className="quick-link-card">
            <h3>About Us</h3>
            <p>Learn about our story and mission</p>
          </Link>
          <Link to="/contact" className="quick-link-card">
            <h3>Contact Us</h3>
            <p>Get in touch with our team</p>
          </Link>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works">
        <h2>How It Works</h2>
        <div className="steps-container">
          <div className="step">
            <div className="step-number">1</div>
            <h3>Tell Us Your Preferences</h3>
            <p>Share your style, budget, and requirements</p>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <h3>Get Matched</h3>
            <p>We'll find diamonds that match your criteria</p>
          </div>
          <div className="step">
            <div className="step-number">3</div>
            <h3>Choose Your Diamond</h3>
            <p>Select from our curated selection</p>
          </div>
          <div className="step">
            <div className="step-number">4</div>
            <h3>Easy Purchase</h3>
            <p>Complete your purchase with confidence</p>
          </div>
        </div>
        <Link to="/contact" className="cta-button">Contact Us</Link>
      </section>

    </div>
  );
};

export default Homepage; 